import type { CalendarRefs, CalendarRef } from '../../../common/types';
import type { Calendars } from '../../../common/utils/calendars/types.tsx';

export const transformToCalendarRefs = (
	updatedCalendarsList: Calendars = [],
	calendarRefsInResource: CalendarRefs = [],
): CalendarRefs => {
	const defaultCalendar = calendarRefsInResource.find((calendar) => calendar.default);
	const transformedCalendarRefs = updatedCalendarsList.map<CalendarRef>(({ id, name }) => ({
		id,
		name,
		default: false,
	}));

	if (!defaultCalendar) {
		return transformedCalendarRefs;
	}

	return [...transformedCalendarRefs, defaultCalendar];
};
